/* Global imports. */
import React from "react";

/* Other imports. */
import { isNumber } from "@src/helpers";

const charsPerMinute: number = 220;
let message: string = "minutes to read";

interface Props {
  numChars: number;
}

function numberOfMinutes(numChars: number) {
  const minutes = Math.ceil(numChars / (5 * charsPerMinute));

  if (minutes === 1) message = "minute to read";

  return minutes;
}

const ReadTime = ({ numChars }: Props) =>
  isNumber(numChars) ? (
    <span className="font-sans text-sm text-gray-500 sm:text-base">
      {numberOfMinutes(numChars)} {message}
    </span>
  ) : null;

export default ReadTime;
